import { useMemo } from "react";

import { OperatorOption } from "src/base-components/FilterPopover/types";
import { Pill } from "src/base-components/Pill";
import { Select } from "src/base-components/Select";

type Props = {
  options: OperatorOption[];
  value: string | undefined;
  onChange: (value: string) => void;
  disabled?: boolean;
  dataLoc?: string;
};

export const OperatorSelect: React.FC<Props> = ({
  options,
  value,
  onChange,
  disabled,
  dataLoc,
}) => {
  const descriptionByKey = useMemo(
    () => new Map(options.map((o) => [o.key, o.value.description])),
    [options],
  );

  const selectOptions = useMemo(
    () =>
      options.map((o) => ({
        key: o.key,
        searchText: o.value.description,
        value: (
          <div className="flex w-40 items-center justify-between gap-x-2">
            <span>{o.value.description}</span>
            <Pill size="sm" variant="gray">
              <Pill.Text fontType="code">
                {o.value.displayCode ?? o.value.code}
              </Pill.Text>
            </Pill>
          </div>
        ),
      })),
    [options],
  );

  return (
    <Select
      buttonRenderer={(option) =>
        option ? (
          <Pill size="sm" variant="gray">
            <Pill.Text>{descriptionByKey.get(option.key)}</Pill.Text>
          </Pill>
        ) : null
      }
      dataLoc={dataLoc}
      disabled={disabled}
      options={selectOptions}
      placeholder=""
      value={value}
      fullWidth
      onChange={onChange}
      optionsFitContent
    />
  );
};
